import React from 'react';
import Answer from './AnswerInput';
import { Grid } from '@mui/material';

const AnswerList = ({
    type,
    choices,
    selectedAnswer,
    question,
    handleAnswerSelection,
}) => {

    return (
        <div style={styles.questionContainer}>
            {
                choices && choices.length ? (
                    <Grid
                        container
                        spacing={1}
                        style={styles.choicesContainer}
                        direction={choices?.[0]?.value?.contentURL ? "row" : "column"}
                        alignItems={choices?.[0]?.value?.contentURL ? undefined : "center"}
                        justifyContent="center"
                    >
                        {choices.map((choice, index) => (
                            <Grid item xs={12} md={choices?.[0]?.value?.contentURL ? 6 : 8} lg={choices?.[0]?.value?.contentURL ? 6 : 6} key={choice.id} sx={{}} container justifyContent="center">
                                <Grid item xs={12} style={{ paddingTop: 0 }}>
                                    <Answer
                                        className='grid-item answer-item'
                                        choice={choice}
                                        index={index}
                                        enableTextToAudio={choice.value?.enableTextToAudio}
                                        onChange={(e) => handleAnswerSelection(e, index)}
                                        type={type}
                                        selectedAnswer={selectedAnswer}
                                    />
                                </Grid>
                            </Grid>
                        ))
                        }
                    </Grid>
                ) : ''
            }


        </div>
    )
}

const styles = {
    questionContainer: {
        marginTop: '30px',
        marginBottom: '40px',
        maxWidth: '900px',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: '24px',
        paddingRight: '24px',
        boxSizing: 'border-box',
    },
    question: {
        fontSize: 'clamp(18px, 4vw, 28px)',
        fontWeight: 500,
        marginBottom: '25px',
        color: 'black',
        lineHeight: 1.3,
    },
    renderer: {
        maxWidth: '100%'
    },
    choicesContainer: {
        padding: 0,
    }
}

export default AnswerList;
